/*
  L'UN navigation controller.
  - moves the hamburger into the header's left column (re-places it after theme-editor section reloads)
  - opens/closes the drawer <dialog>: scroll lock, Esc, backdrop click, focus trap, focus restore
*/
(function () {
  'use strict';

  var CLOSE_MS = 340;
  var root = document.querySelector('[data-lun-nav]');
  if (!root) return;

  var toggle = root.querySelector('[data-lun-nav-open]');
  var dialog = root.querySelector('[data-lun-drawer]');
  if (!toggle || !dialog || typeof dialog.showModal !== 'function') return;

  var html = document.documentElement;
  var closeButton = dialog.querySelector('[data-lun-nav-close]');
  var countEl = dialog.querySelector('[data-lun-nav-count]');
  var lastFocus = null;
  var closeTimer = 0;
  var reducedQuery = window.matchMedia('(prefers-reduced-motion: reduce)');

  function place() {
    var columns = document.querySelector('#header-component .header__row--top .header__columns');
    // Put the button inside the left column when the header renders one: that column occupies the
    // same grid cell, comes later in the DOM and would otherwise sit on top of the button and eat its clicks.
    var host = columns && (columns.querySelector('.header__column--left') || columns);
    if (host && toggle.parentNode !== host) host.insertBefore(toggle, host.firstChild);
    toggle.hidden = false;
  }

  function focusables() {
    return Array.prototype.filter.call(
      dialog.querySelectorAll('a[href], button:not([disabled]), select:not([disabled]), input:not([disabled])'),
      function (el) {
        return el.offsetParent !== null || el === document.activeElement;
      }
    );
  }

  function refreshCount() {
    if (!countEl || !window.fetch) return;
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) {
        return r.ok ? r.json() : null;
      })
      .then(function (cart) {
        if (cart && typeof cart.item_count === 'number') countEl.textContent = String(cart.item_count);
      })
      .catch(function () {});
  }

  function open() {
    if (dialog.open) return;
    window.clearTimeout(closeTimer);
    lastFocus = document.activeElement;
    dialog.showModal();
    html.classList.add('lun-nav-lock');
    toggle.setAttribute('aria-expanded', 'true');
    window.requestAnimationFrame(function () {
      window.requestAnimationFrame(function () {
        dialog.setAttribute('data-open', '');
      });
    });
    var first = dialog.querySelector('.lun-drawer__link') || closeButton;
    if (first) first.focus();
    refreshCount();
  }

  function finish(restoreFocus) {
    window.clearTimeout(closeTimer);
    if (dialog.open) dialog.close();
    dialog.removeAttribute('data-open');
    html.classList.remove('lun-nav-lock');
    toggle.setAttribute('aria-expanded', 'false');
    if (restoreFocus) {
      var target = lastFocus && document.contains(lastFocus) ? lastFocus : toggle;
      target.focus();
    }
  }

  function close(immediate, restoreFocus) {
    if (!dialog.open) return;
    dialog.removeAttribute('data-open');
    if (immediate || reducedQuery.matches) {
      finish(restoreFocus);
    } else {
      window.clearTimeout(closeTimer);
      closeTimer = window.setTimeout(function () {
        finish(restoreFocus);
      }, CLOSE_MS);
    }
  }

  toggle.addEventListener('click', open);
  if (closeButton) {
    closeButton.addEventListener('click', function () {
      close(false, true);
    });
  }

  // Esc: run the closing animation instead of the instant native close
  dialog.addEventListener('cancel', function (event) {
    event.preventDefault();
    close(false, true);
  });

  // Click on the dimmed area outside the panel
  dialog.addEventListener('click', function (event) {
    if (event.target === dialog) close(false, true);
  });

  // Links: close at once; the browser carries on with navigation or the anchor jump
  dialog.addEventListener('click', function (event) {
    var link = event.target.closest && event.target.closest('[data-lun-nav-link]');
    if (link) close(true, false);
  });

  // Focus trap (the native modal also makes the page inert)
  dialog.addEventListener('keydown', function (event) {
    if (event.key !== 'Tab') return;
    var items = focusables();
    if (!items.length) return;
    var first = items[0];
    var last = items[items.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  });

  // Leaving a wide drawer on resize is harmless; nothing to do. Re-place after editor reloads.
  // Any native close (not just ours) must release the scroll lock and reset the toggle.
  dialog.addEventListener('close', function () {
    dialog.removeAttribute('data-open');
    html.classList.remove('lun-nav-lock');
    toggle.setAttribute('aria-expanded', 'false');
  });

  document.addEventListener('shopify:section:load', place);
  document.addEventListener('shopify:section:reorder', place);
  place();
})();
